<template>
  <div>
    <div v-if="type == 'edit'">
      <el-divider><span style="color:#409eff">图片附件</span></el-divider>
      <el-tag type="warning" v-if="tip != null && tip != ''" style="margin-bottom: 12px;">{{ tip }}</el-tag>
      <el-upload :action="getUploadAction()" list-type="picture-card"
        accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PNG,.GIF,.BMP"
        :headers="{ token: this.$store.getUser().token, platform: 'web' }" :file-list="fileList"
        :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess"
        :on-error="handleError" :on-exceed="handleExceed" :limit="max" :data="{ busCode: busCode, type: 'imgs' }">
        <i class="el-icon-plus"></i>
      </el-upload>

      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img :src="dialogImageUrl" style="width:100%">
      </el-dialog>
    </div>
    <div v-if="type == 'view'">
      <template v-if="fileList != null && fileList != '' && fileList != '[]'">
        <el-divider><span style="color:#409eff">图片附件</span></el-divider>
        <el-image v-for="(item, index) in fileList" :key="index"
          style="width:148px;height:148px;margin-right:12px;border-radius: 8px;" :src="item"
          :preview-src-list="fileList">
        </el-image>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'esImg',
  props: ['info', 'fileList', 'busCode', 'dataUrl', 'type', 'max', 'tip'],
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
    }
  },
  methods: {
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess (response) {
      // 存在bug，如果一个页面，同时用两个图片附件

      if (response.code == 200) {
        let i = response.msg.lastIndexOf('/')
        let tempFileList = new Array()
        if (this.info.attachImgs != null)
          tempFileList = JSON.parse(this.info.attachImgs)
        tempFileList.push({ name: response.msg.substring(i + 1), url: '/file/file/down?filename=' + response.msg })
        this.info.attachImgs = JSON.stringify(tempFileList)

        if (this.info.id == null) {
          //如果是新增，则将附件数据回写至业务
          this.$emit('insertAttachImgs', this.info.attachImgs)
        } else {
          this.$ajax.post(this.dataUrl, { attachImgs: this.info.attachImgs, id: this.info.id }).then((msg) => {
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
          })
        }
      } else {
        this.$message.error(response.msg)
      }

    },
    handleError () {
      this.$message.error("上传图片失败，请确认文件是否超出")
    },
    handleRemove (file) {
      let filename
      if (file.response != null) {
        filename = file.response.msg
      } else {
        let s = file.url.indexOf('=')
        let e = file.url.indexOf('&')
        filename = file.url.substring(s + 1, e)
      }
      let files = JSON.parse(this.info.attachImgs)
      let newFiles = files.filter((e) => {
        return !filename.endsWith(e.name)
      })
      let param
      if (newFiles.length == 0) {
        param = null;
      } else {
        param = JSON.stringify(newFiles)
      }
      //物理删除
      this.$ajax.post("/file/file/delete", { fileName: filename }).then((msg) => {
        this.info.attachImgs = JSON.stringify(newFiles)
        //如果是新增不做处理
        if (this.info.id != null) {
          //图片数据更新
          this.$ajax.post(this.dataUrl, { attachImgs: param, id: this.info.id }).then(() => {
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
          })
        }
      }).catch(err => {
        this.$message.error(err)
      })
      // //图片数据更新
      // this.$ajax.post(this.dataUrl, { attachImgs: JSON.stringify(newFiles), id: this.info.id }).then(() => {
      //   this.info.attachImgs = JSON.stringify(newFiles)
      //   //物理删除
      //   this.$ajax.post("/file/file/delete", { fileName: filename }).then((msg) => {
      //     this.$message.success(msg)
      //   }).catch(err => {
      //     this.$message.error(err)
      //   })
      // }).catch(err => {
      //   this.$message.error(err)
      // })
    },
    handleExceed () {
      this.$message.error("超出最大上传图片数")
    },
    getUploadAction() {
      return   this.$api+"/file/file/upload";
    },
  },

}
</script>

<style scoped>

</style>